import jwtDecode from 'jwt-decode';

export const AUTH_TOKEN_COOKIE = 'auth_token';
export const ERP_SESSION_COOKIE = 'erp_session';
export const REQUIRED_ROLE = 'ROLE_DOCS_ADMIN';
export const TOKEN_EXPIRY_MARGIN_MS = 30 * 1000;

function getCookieOptions() {
  const secure = window.location.protocol === 'https:' ? '; secure' : '';
  return `path=/; samesite=lax${secure}`;
}

export function getErpUrl() {
  const { protocol, hostname } = window.location;
  const parts = hostname.split('.');
  const subdomain = parts[0];
  const domain = parts.slice(1).join('.');
  return `${protocol}//${subdomain}.${domain}/erp`;
}

export function getErpTokenUrl() {
  return `${getErpUrl()}/auth/token`;
}

export function getErpLoginUrl() {
  return `${getErpUrl()}/login/auth`;
}

export function getCurrentTenant() {
  return window.location.hostname.split('.')[0] || 'kroton';
}

export function getAuthTokenCookie() {
  const match = document.cookie.match(new RegExp(`${AUTH_TOKEN_COOKIE}=([^;]+)`));
  return match ? match[1] : null;
}

export function setAuthCookie(token) {
  document.cookie = `${AUTH_TOKEN_COOKIE}=${token}; ${getCookieOptions()}`;
}

export function setSessionCookie(session) {
  document.cookie = `${ERP_SESSION_COOKIE}=${session}; ${getCookieOptions()}`;
}

export function clearAuthCookies() {
  document.cookie = `${AUTH_TOKEN_COOKIE}=; ${getCookieOptions()}; max-age=0`;
  document.cookie = `${ERP_SESSION_COOKIE}=; ${getCookieOptions()}; max-age=0`;
}

export function redirectToErp() {
  clearAuthCookies();
  window.location.href = getErpLoginUrl();
}

export function isTokenExpired(token, marginMs = TOKEN_EXPIRY_MARGIN_MS) {
  if (!token) return true;
  try {
    const { exp } = jwtDecode(token);
    return exp * 1000 <= Date.now() + marginMs;
  } catch {
    return true;
  }
}

export function isValidToken() {
  const token = getAuthTokenCookie();
  if (!token) return false;
  return !isTokenExpired(token, 0);
}

export function hasRequiredRole() {
  const token = getAuthTokenCookie();
  if (!token) return false;
  try {
    const { roles } = jwtDecode(token);
    return (roles || []).includes(REQUIRED_ROLE);
  } catch {
    return false;
  }
}
